import Home from "./pages/Home";
import Main from "./pages/Home";

function App() {
  return (
    <div className="App">
         <Home/>
    </div>
  );
}

export default App;
